import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, RedirectCommand, Route, Router } from '@angular/router';
import { FeatureFlagsService } from '@coin/shared/core/data-access';

// Usable in both canMatch and canActivate arrays.
export const environmentGuard = (route: Route | ActivatedRouteSnapshot): boolean | RedirectCommand => {
  const router = inject(Router);
  const featureFlagService = inject(FeatureFlagsService);

  const { featureFlag } = route.data ?? {};
  if (!featureFlag || featureFlagService.isActive(featureFlag)) {
    return true;
  }
  return new RedirectCommand(router.createUrlTree(['']));
};
